import { Component, inject, Input, OnInit, OnChanges, SimpleChanges, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProductMediasModalComponent } from '@b2b/features/product/components/product-medias-modal/product-medias-modal.component';
import { TAB_GALLERY } from '@b2b/features/product/components/product-medias-modal/product-medias-modal.model';
import { ProductImageService } from '@b2b/features/product/core/services/product-image.service';
import { Product, PRODUCT_MEDIA_TYPE, ProductImageContainer } from '@b2b/features/product/core/utilities/product.model';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { ProductThumbImagesComponent } from '@b2b/components/product/product-gallery/product-thumb-images/product-thumb-images.component';
import { Media } from '@app/core/models/atomics.model';
import { MediaComponent } from '@shared/components/media/media.component';
import { ProductService } from '@b2b/features/product/core/services/product.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'product-gallery',
  templateUrl: './product-gallery.component.html',
  styleUrl: './product-gallery.component.scss',
  imports: [CommonModule, ProductThumbImagesComponent, MediaComponent, TranslateModule],
})
export class ProductGalleryComponent implements OnInit, OnChanges {
  @Input({ required: true }) product!: Product;

  imageNotFound!: Media;
  imgError = false;

  readonly TAB_GALLERY = TAB_GALLERY;
  readonly currentImage = signal<ProductImageContainer | null>(null);

  private productImageService = inject(ProductImageService);
  private modalService = inject(
    ModalService<{
      product: Product | undefined;
      currentImage: ProductImageContainer | undefined;
      tab: TAB_GALLERY;
    }>,
  );
  productService = inject(ProductService);
  price = toSignal(this.productService.getPrice(), { initialValue: { isLoading: false, data: null, error: null } });

  ngOnInit(): void {
    this.updateProductImage();
    this.imageNotFound = this.productImageService.getImageNotFound(PRODUCT_MEDIA_TYPE.PRODUCT);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product'] && !changes['product'].firstChange) {
      this.updateProductImage();
    }
  }

  onSetContainer(imageContainer: ProductImageContainer) {
    this.currentImage.set(imageContainer);
  }

  openMediasModal(tab: TAB_GALLERY) {
    this.modalService.create({
      id: 'product-medias-modal',
      title: '',
      width: 1000,
      component: ProductMediasModalComponent,
      data: {
        product: this.product,
        currentImage: this.currentImage()!,
        tab,
      },
    });
  }

  onImageError(event: Event) {
    this.imgError = true;
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.imageNotFound.src;
  }

  private updateProductImage(): void {
    const imageContainer = this.productImageService.getImageContainer(this.product, PRODUCT_MEDIA_TYPE.ZOOM);
    this.currentImage.set(imageContainer);
  }
}
